var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScatter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 26H2V4.5C2 4.25 1.75 4 1.5 4H0.5C0.1875 4 0 4.25 0 4.5V27C0 27.5625 0.4375 28 1 28H31.5C31.75 28 32 27.8125 32 27.5V26.5C32 26.25 31.75 26 31.5 26ZM10 19.5C10.8125 19.5 11.5 18.875 11.5 18C11.5 17.1875 10.8125 16.5 10 16.5C9.125 16.5 8.5 17.1875 8.5 18C8.5 18.875 9.125 19.5 10 19.5ZM26 9.5C26.8125 9.5 27.5 8.875 27.5 8C27.5 7.1875 26.8125 6.5 26 6.5C25.125 6.5 24.5 7.1875 24.5 8C24.5 8.875 25.125 9.5 26 9.5ZM12 9.5C12.8125 9.5 13.5 8.875 13.5 8C13.5 7.1875 12.8125 6.5 12 6.5C11.125 6.5 10.5 7.1875 10.5 8C10.5 8.875 11.125 9.5 12 9.5ZM24 19.5C24.8125 19.5 25.5 18.875 25.5 18C25.5 17.1875 24.8125 16.5 24 16.5C23.125 16.5 22.5 17.1875 22.5 18C22.5 18.875 23.125 19.5 24 19.5ZM18 15.5C18.8125 15.5 19.5 14.875 19.5 14C19.5 13.1875 18.8125 12.5 18 12.5C17.125 12.5 16.5 13.1875 16.5 14C16.5 14.875 17.125 15.5 18 15.5Z",
    fill: "#97AEB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScatter);
export default __webpack_public_path__ + "static/media/scatter.e4556768.svg";
export { ForwardRef as ReactComponent };